<div class="gp-addon-selector">
  <wai-sepa-payment-setup
    *ngIf="pendingAddonForSepa"
    [billingName]="billingContactName"
    [billingEmail]="billingContactEmail"
    [processing]="isLoading"
    (completed)="onSepaSetupCompleted($event)"
    (cancelled)="onSepaSetupCancelled()"
  ></wai-sepa-payment-setup>

  <div class="addon-pending-banner" *ngIf="hasPendingAddonActivations()">
    <mat-icon>hourglass_top</mat-icon>
    <span>{{ 'INTL_ADDON_PAYMENT_PROCESSING' | translate }}</span>
  </div>

  <h3 *ngIf="availableAddons$ | async as addons">{{ 'INTL_AVAILABLE_ADDONS' | translate }}</h3>

  <div class="addon-grid" *ngIf="availableAddons$ | async as addons">
    <mat-card *ngFor="let addon of addons" class="addon-card"
      [class.active]="isAddonActive(addon.uid)"
      [class.pending]="isAddonPendingActivation(addon.uid)">
      <mat-card-header>
        <mat-card-title>
          <mat-icon [ngClass]="getAddonColorClass(addon.addonType)">{{ getAddonIcon(addon.addonType) }}</mat-icon>
          <div class="addon-title-row">
            <span [ngClass]="getAddonColorClass(addon.addonType)">{{ addon.name }}</span>
            <div *ngIf="isAddonActive(addon.uid)" class="active-badge">
              <span class="badge-text">{{ 'INTL_ACTIVE' | translate }}</span>
            </div>
            <div *ngIf="isAddonPendingActivation(addon.uid)" class="pending-badge">
              <mat-spinner diameter="14"></mat-spinner>
              <span class="badge-text">{{ 'INTL_PAYMENT_PROCESSING' | translate }}</span>
            </div>
          </div>
        </mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="addon-features" *ngIf="addon.description">
          <h4>{{ 'INTL_FEATURES' | translate }}:</h4>
          <ng-container *ngIf="getDescriptionList(addon.description) as descriptionItems">
            <ul class="addon-description-list" *ngIf="descriptionItems.length > 1">
              <li *ngFor="let item of descriptionItems">
                <span>{{ item }}</span>
              </li>
            </ul>
            <p *ngIf="descriptionItems.length === 1">{{ addon.description }}</p>
          </ng-container>
        </div>
      </mat-card-content>

      <mat-card-actions align="end">
        <p *ngIf="isAddonPendingActivation(addon.uid)" class="pending-addon-hint">
          {{ 'INTL_ADDON_ACTIVATION_PENDING_HINT' | translate }}
        </p>
        <button *ngIf="!isAddonActive(addon.uid) && !isAddonPendingActivation(addon.uid)" mat-raised-button color="primary"
          [disabled]="isLoading || disablePurchase" (click)="onPurchaseAddon(addon)" class="purchase-button">
          <mat-spinner *ngIf="isAddonLoading(addon.uid)" diameter="16" class="button-spinner"></mat-spinner>
          <span *ngIf="!isAddonLoading(addon.uid)" class="purchase-button-content">
            <mat-icon>add_shopping_cart</mat-icon>
            <span class="purchase-button-text">{{ 'INTL_ADD_NOW' | translate }}</span>
          </span>
        </button>
        <button *ngIf="isAddonActive(addon.uid)" mat-icon-button color="warn" [disabled]="isLoading"
          (click)="onRemoveAddon(addon.uid)" class="remove-button" [attr.aria-label]="'INTL_REMOVE_ADDON' | translate">
          <mat-spinner *ngIf="isAddonLoading(addon.uid)" diameter="20" class="button-spinner"></mat-spinner>
          <mat-icon *ngIf="!isAddonLoading(addon.uid)">delete</mat-icon>
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
